import React, { useCallback } from "react";
import { Confirmar } from "../../../components";
import { useDispatch } from "react-redux";
import {
  cashbackCloseModal,
  deleteCashback,
} from "./reducers/cashback-actions";
import { useToggle } from "react-use";

const STR = {
  title: "Excluir Cashback",
  subtitle: "Deseja realmente excluir o cashback?",
};

function CashbackDelete({ id }) {
  const dispatch = useDispatch();
  const [wait, setWait] = useToggle();

  const onCancel = useCallback(() => {
    dispatch(cashbackCloseModal());
  }, [dispatch]);
  //
  const onConfirm = useCallback(() => {
    dispatch(
      deleteCashback(
        {
          id,
        },
        setWait
      )
    );
  }, [dispatch, id, setWait]);
  //
  return (
    <Confirmar
      titulo={STR.title}
      subtitulo={STR.subtitle}
      fnCancelar={onCancel}
      fnConfirmar={onConfirm}
      aguardar={wait}
    />
  );
}

export default CashbackDelete;
